import router from "@/router";

export default {
  state: {
    token: localStorage.getItem("token"),
    userName: localStorage.getItem("userName")
  },
  mutations: {
    logout(state) {
      state.token = "";
      state.userName = "";
      localStorage.removeItem("token");
      localStorage.removeItem("userName");
      router.push("/login");
    },
    login(state, payload) {
      state.token = payload.token;
      localStorage.token = payload.token;
      localStorage.userName = payload.userName;
    },
    refreshToken(state, payload) {
      state.token = payload.token;
      localStorage.token = payload.token;
    }
  },
  actions: {},
  getters: {
    getToken: state => state.token
  }
};
